'use client';
import { jsx } from 'react/jsx-runtime';
import t from 'prop-types';
import { useComponentStylesLoaded } from '../../hooks/use-component-styles-loaded.js';
import { renderWithRef } from '../core/render-with-ref.js';
import { SWAN_STYLE_KEY_MAP } from '../head/stylesheets.component.js';
import { RenderComp } from '../core/render-comp.component.js';
import { deprecatedProp } from '../core/deprecated-prop.js';

let l = {
    variant: t.oneOf([
        'card',
        'full-width-image'
    ]),
    twoImages: t.bool,
    multiColumnOffer: t.bool,
    height: t.oneOf([
        'standard',
        'short'
    ]),
    textHorizontalAlignOnExtraSmall: deprecatedProp(t.oneOf([
        'left',
        'center'
    ]), 'The text will be by default center aligned on extra small screen size devices and to maintain the consistent user experience, we are deprecating this prop.'),
    textBoxHorizontalAlign: t.oneOf([
        'left',
        'center',
        'right'
    ]),
    withLeftHandNavigation: t.bool,
    preferSecondaryImage: t.bool,
    hideImageOnExtraSmall: t.bool,
    editorial: t.bool,
    imageFocalPoint: deprecatedProp(t.oneOf([
        'left top',
        'left center',
        'left bottom',
        'center top',
        'center center',
        'center bottom',
        'right top',
        'right center',
        'right bottom'
    ]), "This prop is deprecated and will be removed in a future release. Please set 'imageFocalPoint' on 'BannerImage' or 'BannerSecondaryImage' instead.")
}, d = Object.keys(l);
const Banner = renderWithRef('Banner', l, (a, n)=>{
    useComponentStylesLoaded('Banner', SWAN_STYLE_KEY_MAP.banner);
    let { children: r, height: l, textHorizontalAlignOnExtraSmall: s, textBoxHorizontalAlign: m = 'left', variant: c = 'card', twoImages: f = false, multiColumnOffer: p = false, withLeftHandNavigation: b = false, preferSecondaryImage: g = false, hideImageOnExtraSmall: h = false, editorial: w = false, imageFocalPoint: x } = a, u = new Set([
        'swan-banner'
    ]);
    return u.add(`swan-banner-${c}`), s && u.add(`swan-banner-text-horizontal-align-on-extra-small-${s}`), m && u.add(`swan-banner-text-box-horizontal-align-${m}`), 'short' === l && u.add('swan-banner-short'), f && 'card' === c && u.add('swan-banner-two-images'), p && u.add('swan-banner-multi-column-offer'), b && 'card' === c && 'left' === m && u.add('swan-banner-with-left-hand-navigation'), g && u.add('swan-banner-prefer-secondary-image'), h && u.add('swan-banner-hide-image-on-extra-small'), w && u.add("swan-banner-editorial"), x && u.add(`swan-banner-image-focal-point-${x.replace(/ +/g, '-')}`), jsx(RenderComp, {
        root: "div",
        forwardedRef: n,
        propKeysToRemove: d,
        classNames: u,
        props: a,
        children: r
    });
});

export { Banner };
